var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"recruit",attrs:{"src":_vm.prefixURL + 'appLark.png',"alt":""}}),_c('van-button',{staticClass:"apply",attrs:{"text":"立即申请","block":"","to":"applyPublishers"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }